var React = require('react');

function Camera (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M344 288a88 88 0 1 1-88-88 88.13 88.13 0 0 1 88 88z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M464 96h-88l-12.4-32.9A47.93 47.93 0 0 0 318.7 32H193.2a47.93 47.93 0 0 0-44.9 31.1L136 96H48a48 48 0 0 0-48 48v288a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V144a48 48 0 0 0-48-48zM256 408a120 120 0 1 1 120-120 120.1 120.1 0 0 1-120 120z","className":"fa-primary","key":2})]);
}

Camera.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Camera;

Camera.default = Camera;
